import { FaChartLine, FaBookOpen, FaMoneyBill, FaClock, FaHandsHelping, FaArrowUp } from 'react-icons/fa';
import { images } from '../constants'; 


const careerIntro = {
    sub: "Join Our Team",
    heading: "Join the Locksmith Crew Today",
    description:
        "At Locksmith, we're seeking committed individuals to join our team of security experts. Explore rewarding career opportunities in locksmithing and security services. Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem enim nobis ea quo sint vero laboriosam ex repellendus.",
    points: [
        "Opportunities in Locksmithing",
        "Assist in Security Operations",
        "Advanced Locksmith Training Programs",
        "Security Situation Management",
        "Support in Security Measures",
    ],
    image: {
        src1: images.careerIntro1,
        src2: images.careerIntro2,
        src3: images.careerIntro3,
        alt1: "Career-Image1",
        alt2: "Career-Image2",
        alt3: "Career-Image3",
    },
};


const benefits = [
    {
        id: 1,
        icon: <FaChartLine />,
        title: "Career Advancement",
        description: "Explore opportunities for career growth and advancement within the locksmithing and security services industry.",
    },
    {
        id: 2,
        icon: <FaBookOpen />,
        title: "Training Programs",
        description: "Participate in comprehensive training programs to enhance your skills and knowledge in locksmithing and modern security techniques.",
    },
    {
        id: 3,
        icon: <FaMoneyBill />,
        title: "Competitive Pay",
        description: "Enjoy competitive pay packages and benefits while working in the locksmith and security sector.",
    },
    {
        id: 4,
        icon: <FaClock />,
        title: "Flexible Hours",
        description: "Benefit from flexible working hours that fit your lifestyle and accommodate emergency locksmith service demands.",
    },
    {
        id: 5,
        icon: <FaHandsHelping />,
        title: "Team Support",
        description: "Experience a collaborative team environment where trust, cooperation, and support drive success in security solutions.",
    },
    {
        id: 6,
        icon: <FaArrowUp />,
        title: "Growth Potential",
        description: "Unlock your professional potential with clear paths for advancement in the locksmithing and security field.",
    },
];


const positions = [
    {
        id: 1,
        image: images.position1,
        title: 'Locksmith Technician',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Preferred: 2+ Years in Locksmithing or Security Services',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$50K - $65K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'Install, repair, and maintain locks, keys, safes, and security systems. Locksmith Technicians are expected to provide expert solutions, respond to emergencies, and ensure high standards of safety and reliability.',
        ],
        responsibilities: [
            'Install and repair various types of locks, including deadbolts and electronic systems.',
            'Respond to emergency lockout situations for homes, vehicles, or businesses.',
            'Cut keys, rekey locks, and program electronic locking devices.',
            'Diagnose problems in security systems and recommend solutions.',
            'Maintain accurate records of services provided and materials used.',
            'Follow safety protocols and maintain clean, organized workspaces.',
        ],
        qualifications: [
            'High school diploma or equivalent; technical or locksmith certification preferred.',
            '2+ years of experience in locksmithing or related field.',
            'Knowledge of mechanical and electronic locking systems.',
            'Problem-solving skills and attention to detail.',
            'Ability to handle tools and equipment safely and efficiently.',
            'Strong communication skills and ability to work independently or in a team.',
        ],
    },
    {
        id: 2,
        image: images.position2,
        title: 'Security Specialist',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Preferred: 3+ Years in Security Operations or Surveillance',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$55K - $70K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'Monitor, evaluate, and enhance security measures to protect property, personnel, and assets. Security Specialists are responsible for implementing surveillance, responding to threats, and maintaining a secure environment.',
        ],
        responsibilities: [
            'Develop and implement security protocols and emergency response plans.',
            'Monitor surveillance systems and conduct routine security checks.',
            'Investigate security breaches, incidents, and alarms.',
            'Coordinate with local law enforcement when necessary.',
            'Prepare detailed reports on security incidents and updates.',
            'Train staff on safety procedures and security awareness.',
        ],
        qualifications: [
            'High school diploma or equivalent; degree in criminal justice or security is a plus.',
            '3+ years of experience in security operations or surveillance.',
            'Familiarity with CCTV systems, access control, and alarm systems.',
            'Excellent observation and problem-solving skills.',
            'Strong verbal and written communication abilities.',
            'Ability to remain calm and effective under pressure.',
        ],
    },
    {
        id: 3,
        image: images.position3,
        title: 'Key Technician',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Preferred: 1–2 Years in Key Cutting or Locksmith Services',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$40K - $55K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'Specialize in key cutting, duplication, and lock servicing. Key Technicians ensure precision work in producing keys, programming transponders, and supporting clients with lock-and-key solutions.',
        ],
        responsibilities: [
            'Cut and duplicate keys using manual and electronic machines.',
            'Program transponder and electronic keys for various lock types.',
            'Repair or rekey locks and ensure key compatibility.',
            'Assist with customer service and key-related inquiries.',
            'Maintain and calibrate key-cutting equipment.',
            'Keep inventory of blank keys and related components.',
        ],
        qualifications: [
            'High school diploma or equivalent.',
            '1–2 years of experience in key cutting or locksmith support roles.',
            'Familiarity with key-cutting machines and basic locksmith tools.',
            'Attention to accuracy and fine detail.',
            'Good communication and customer service skills.',
            'Willingness to learn and adapt to new locking technologies.',
        ],
    },
    {
        id: 4,
        image: images.position4,
        title: 'Security Consultant',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Preferred: 3+ Years in Security Consulting or Risk Assessment',
            position: 'Limited Openings',
            days: 'Monday to Friday',
            salary: '$75K - $90K',
            deadline: 'Apply Now - Applications Reviewed on Rolling Basis',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'Provide expert advice on physical and electronic security measures. Security Consultants assess vulnerabilities, develop protection strategies, and support clients in enhancing overall safety and compliance.',
        ],
        responsibilities: [
            'Conduct on-site risk assessments and security audits.',
            'Develop tailored security plans and recommendations.',
            'Evaluate surveillance, access control, and alarm systems.',
            'Prepare detailed security reports and improvement strategies.',
            'Stay up to date on industry standards and threats.',
            'Collaborate with internal teams and external stakeholders.',
        ],
        qualifications: [
            'Bachelor’s degree in Criminal Justice, Security Management, or related field.',
            '3+ years of experience in security consulting or law enforcement.',
            'Strong analytical and problem-solving skills.',
            'Familiarity with modern security systems and technologies.',
            'Excellent communication and presentation skills.',
            'Ability to work independently and travel as needed.',
        ],
    },
    {
        id: 5,
        image: images.position5,
        title: 'Locksmith Apprentice',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'No Prior Experience Required – Training Provided',
            position: 'Openings Available',
            days: 'Monday to Friday',
            salary: '$30K - $40K',
            deadline: 'Apply Now – Training Slots Filling Fast',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'Assist experienced locksmiths in providing lock installation, repair, and emergency unlocking services. Gain hands-on experience while learning the essential skills and safety practices of the locksmithing trade.',
        ],
        responsibilities: [
            'Support senior locksmiths in daily field operations.',
            'Observe and assist with lock installation and repairs.',
            'Learn to cut keys and rekey locks under supervision.',
            'Help maintain tools, equipment, and service vehicles.',
            'Respond to service calls with a customer-first mindset.',
            'Adhere to all safety and company protocols.',
        ],
        qualifications: [
            'High school diploma or equivalent.',
            'Willingness to learn and follow instructions.',
            'Basic mechanical aptitude and attention to detail.',
            'Good communication and teamwork skills.',
            'Valid driver’s license and clean driving record.',
            'Ability to lift up to 50 lbs and work on-site.',
        ],
    },
    {
        id: 6,
        image: images.position6,
        title: 'Security Officer',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Rotational Shifts – Day & Night',
            experience: 'Preferred: 1+ Years in Security or Law Enforcement',
            position: 'Immediate Openings',
            days: 'Monday to Sunday (Shift Based)',
            salary: '$35K - $50K',
            deadline: 'Apply Immediately – Positions Filling Fast',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'Ensure the safety and security of company property, personnel, and clients. Security Officers are responsible for monitoring surveillance systems, conducting patrols, and managing access control procedures.',
        ],
        responsibilities: [
            'Conduct routine patrols of premises to prevent and detect signs of intrusion.',
            'Monitor surveillance cameras and alarm systems.',
            'Control access to restricted areas and verify credentials.',
            'Respond promptly to incidents, alarms, and emergencies.',
            'Write detailed reports on daily activities and irregularities.',
            'Collaborate with law enforcement and emergency services when required.',
        ],
        qualifications: [
            'High school diploma or GED equivalent.',
            '1+ years of experience in a security-related role preferred.',
            'Strong observational and decision-making skills.',
            'Knowledge of security protocols and emergency procedures.',
            'Excellent communication and reporting abilities.',
            'Physical stamina to stand, walk, or patrol for extended periods.',
        ],
    }

];

export { positions, benefits, careerIntro };